import { render, staticRenderFns } from "./SNavigationDrawer.vue?vue&type=template&id=0612fafa&scoped=true&lang=pug"
import script from "./SNavigationDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SNavigationDrawer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SNavigationDrawer.vue?vue&type=style&index=0&id=0612fafa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0612fafa",
  null
  
)

export default component.exports